module.exports = __webpack_public_path__ + "static/media/image 28.59f8be14.png";